export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14203.127265e8.jpg";